import { IPlanKey } from '../types';

export const COMPARE_PLAN_SHOW_USAGE_FEE = IPlanKey.FUNNEL_OPT;
